/* eslint-disable no-restricted-globals */
import { useEffect, useState } from 'react';
import { getScreenOrientation } from './utils';

export const useScreenOrientation = () => {
  const [orientation, setOrientation] = useState(getScreenOrientation());

  useEffect(() => {
    const handleOrientationChange = () => setOrientation(getScreenOrientation());

    if (screen.orientation) {
      screen.orientation.addEventListener('change', handleOrientationChange);
    }

    return () => {
      if (screen.orientation) {
        screen.orientation.removeEventListener('change', handleOrientationChange);
      }
    };
  }, []);

  return orientation;
};
